export default __webpack_public_path__ + "static/media/Transfer.b98744a5.svg";